import { FormObjType } from "DataTypes/Form";

export const ResultForm: FormObjType[] = [
  {
    id: "resultName",
    label: "Result Name",
    placeholder: "Enter Result Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "observationName",
    label: "Observation Name",
    placeholder: "Enter Observation Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "dateTime",
    label: "Observation Date",
    placeholder: "Select Observation Date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "observationValue",
    label: "Observation Value",
    placeholder: "Enter Observation Value",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "observationUnit",
    label: "Observation Unit",
    placeholder: "Enter Observation Unit",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
]